import React from 'react';
import { Badge, Col, Dropdown, Row } from 'react-bootstrap';

function Dropdowns() {
  return (
    <Row className="styles-section" id="dropdowns"  >
      <Col xs={12}>
        <h3>Dropdowns</h3>
      </Col>

      <Col xs={6}>
        <Dropdown style={{ minHeight: 300 }}>
          <Dropdown.Toggle>
            Dropdown Button
            <i className="fal fa-angle-down" />
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item href="#/action-1">Action</Dropdown.Item>
            <Dropdown.Item href="#/action-2">
              <input type="checkbox" aria-label="Checkbox for following text input" />
              Checkbox
            </Dropdown.Item>
            <Dropdown.Item href="#/action-3">
              <input type="radio" aria-label="Radio button for following text input" />
              Radio
            </Dropdown.Item>
            <Dropdown.Divider />
            <Dropdown.Item href="#/action-4">
              <i className="fal fa-briefcase"></i>
              Icon item
            </Dropdown.Item>
            <Dropdown.Item href="#/action-4">
              Icon item
              <Badge className="right" variant="dark">Status</Badge>
            </Dropdown.Item>
            <Dropdown.Item href="#/action-4">
              Icon item
              <Badge className="right" variant="light">707</Badge>
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </Col>

      <Col xs={6} >
        <Dropdown style={{ minHeight: 300 }}>
          <Dropdown.Toggle disabled>
            Dropdown Button
            <i className="fal fa-angle-down" />
          </Dropdown.Toggle>

        </Dropdown>
      </Col>

      <Col xs={6} >
        <Dropdown style={{ minHeight: 300 }}>
          <Dropdown.Toggle variant="danger">
            Dropdown Button
            <i className="fal fa-angle-down" />
          </Dropdown.Toggle>

        </Dropdown>
      </Col>

      <Col xs={6}>
        <Dropdown.Menu show className="preview" style={{ minHeight: 300 }}>
          <Dropdown.Header>Dropdown header</Dropdown.Header>
          <Dropdown.Item href="#/action-1">Action</Dropdown.Item>
          <Dropdown.Item href="#/action-2">
            <input type="checkbox" aria-label="Checkbox for following text input" />
            Checkbox
          </Dropdown.Item>
          <Dropdown.Item href="#/action-3">
            <input type="radio" aria-label="Radio button for following text input" />
            Radio
          </Dropdown.Item>
          <Dropdown.Divider />
          <Dropdown.Item href="#/action-4">
            <i className="fal fa-briefcase"></i>
            Icon item
          </Dropdown.Item>
          <Dropdown.Item href="#/action-4">
            Icon item
            <Badge className="right" variant="dark">Status</Badge>
          </Dropdown.Item>
          <Dropdown.Item href="#/action-4">
            Icon item
            <Badge className="right" variant="light">707</Badge>
          </Dropdown.Item>
        </Dropdown.Menu>
      </Col>
    </Row>);
}

export default Dropdowns;